import { Injectable, Pipe, PipeTransform } from '@angular/core';
import {
  getQuantityTypeLabels,
  quantityToTime,
  QuantityType,
  QuantityTypeLabels,
} from '../models/quote-item-data.model';
import { formatVolumeFromM3 } from '../utils/volume-format';

export interface QuantityPipeValue {
  quantity: number | string;
  quantity_type: QuantityType;
}

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'quantity',
})
export class QuantityPipe implements PipeTransform {
  transform(
    value: QuantityPipeValue,
    labelType: 'short' | 'long' | 'input' | 'list' = 'short',
  ): string {
    const quantity = value.quantity;
    const parsedQuantity = Number(quantity);
    const numericQuantity = Number.isFinite(parsedQuantity)
      ? parsedQuantity
      : 0;
    const quantityType = value.quantity_type;

    if (labelType === 'input') {
      if (quantityType === QuantityType.HOURLY) {
        const [hours, mins, secs] = quantityToTime(numericQuantity);
        return `${hours}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      }
      return String(quantity);
    }

    if (quantityType === QuantityType.HOURLY) {
      const [hours, mins, secs] = quantityToTime(numericQuantity);
      let return_string = '';
      if (hours > 0) {
        return_string += hours + 'h';
      }
      if (hours > 0 && (mins > 0 || secs > 0)) {
        return_string += ' ';
      }
      if (mins > 0) {
        return_string += mins + 'm';
      }
      if (mins > 0 && secs > 0) {
        return_string += ' ';
      }
      if (secs > 0) {
        return_string += secs + 's';
      }
      return return_string || '0s';
    }

    if (
      quantityType === QuantityType.CUBIC_METER &&
      (labelType === 'short' || labelType === 'list')
    ) {
      return formatVolumeFromM3(numericQuantity);
    }

    const label_config =
      quantityType in QuantityTypeLabels
        ? getQuantityTypeLabels(quantityType)
        : null;
    if (!label_config) return '';
    if (labelType === 'long') {
      return label_config.long_label;
    }
    const displayQuantity =
      labelType === 'list'
        ? Number(numericQuantity.toFixed(6)).toString()
        : quantity.toString();
    return `${displayQuantity} ${
      numericQuantity === 1
        ? label_config.label_singular
        : label_config.label_plural
    }`;
  }
}
